import './card.css';

const SmallCardSkeleton = () => {
  return (
    <div className="card-skeleton">
      <div className="card">
        <div className="card-image"></div>
        <div className="card-body">
          <div className="card-title"></div>
          <div className="card-subtitle"></div>
          <div className="card-footer"></div>
        </div>
      </div>
    </div>
  );
};

export default SmallCardSkeleton;
